import { observer } from 'mobx-react';
import * as React from 'react';
import { TextArea } from 'telia-front-react';
function TextareaContainer(props) {
    const { field, helpMessage, errorMessage, callback } = props;
    const input = {
        maxLength: field.maxLength,
        placeholder: field.placeholder,
        autoComplete: 'off'
    };
    return (React.createElement(TextArea, { ...field, id: `field-${field.id}`, value: field.getValue(), helpMessage: helpMessage, errorMessage: errorMessage, input: input, onChange: (text) => {
            field.setValue(text);
            callback(field);
        }, required: field.isRequired, hideLabel: field.labelHidden ? 'no-break' : undefined }));
}
export default observer(TextareaContainer);
//# sourceMappingURL=Textarea.js.map